import { api } from '../services/axiosConfig';
import { ShareGroup } from '../types';

export const fetchShareGroups = () => api.get<ShareGroup[]>('/api/share-groups').then((r) => r.data);

export const createShareGroup = (name: string) => api.post<ShareGroup>('/api/share-groups', { name }).then((r) => r.data);

export const deleteShareGroup = (id: number) => api.delete(`/api/share-groups/${id}`);

export const addShareGroupMember = (groupId: number, characterId: number) =>
  api.post(`/api/share-groups/${groupId}/members`, { characterId });

export const removeShareGroupMember = (groupId: number, characterId: number) =>
  api.delete(`/api/share-groups/${groupId}/members/${characterId}`);
